import { FormType } from '../../../form-types';

import { AntiNauseaQuestionFieldAnswers } from './questions';

const antiNausea: FormType<AntiNauseaQuestionFieldAnswers> = {
  name: 'Anti-Nausea',
  questions: [
    {
      key: 'antiNausea_educationalInfo',
      next: {
        condition: { 'antiNausea_educationalInfo.do_not_proceed': true },
        key: 'antiNausea_ineligible',
        els: 'antiNausea_sexAssignedAtBirth'
      }
    },
    {
      key: 'antiNausea_sexAssignedAtBirth',
      next: {
        switch: [
          {
            condition: { 'antiNausea_sexAssignedAtBirth.male': true },
            key: 'antiNausea_height'
          },
          {
            condition: { 'antiNausea_sexAssignedAtBirth.female': true },
            key: 'antiNausea_pregnancyStatus'
          }
        ]
      }
    },
    {
      key: 'antiNausea_pregnancyStatus',
      next: {
        switch: [
          {
            condition: { 'antiNausea_pregnancyStatus.yes': true },
            key: 'antiNausea_ineligible'
          },
          {
            condition: { 'antiNausea_pregnancyStatus.no': true },
            key: 'antiNausea_consentPregnancy'
          }
        ]
      }
    },
    {
      key: 'antiNausea_consentPregnancy',
      next: {
        condition: { 'antiNausea_consentPregnancy.do_not_continue': true },
        key: 'antiNausea_ineligible',
        els: 'antiNausea_height'
      }
    },
    'antiNausea_height',
    'antiNausea_weight',
    'antiNausea_duration',
    {
      key: 'antiNausea_trigger',
      next: {
        switch: [
          {
            condition: { 'antiNausea_trigger.medication_side_effect': true },
            key: 'antiNausea_medicationCausingReaction'
          },
          {
            condition: { 'antiNausea_trigger.other': true },
            key: 'antiNausea_otherCause'
          }
        ],
        els: 'antiNausea_fluidsKeptDown'
      }
    },
    {
      key: 'antiNausea_medicationCausingReaction',
      next: {
        switch: [
          {
            condition: { 'antiNausea_trigger.other': true },
            key: 'antiNausea_otherCause'
          }
        ],
        els: 'antiNausea_fluidsKeptDown'
      }
    },
    {
      key: 'antiNausea_otherCause',
      next: {
        key: 'antiNausea_fluidsKeptDown'
      }
    },
    {
      key: 'antiNausea_fluidsKeptDown',
      next: {
        condition: {
          'antiNausea_fluidsKeptDown.no_everything_comes_back_up': true
        },
        key: 'antiNausea_ineligible',
        els: 'antiNausea_redFlagSymptoms'
      }
    },
    {
      key: 'antiNausea_redFlagSymptoms',
      next: {
        condition: {
          'antiNausea_redFlagSymptoms.none': true
        },
        key: 'antiNausea_medicationsCheck',
        els: 'antiNausea_ineligible'
      }
    },
    {
      key: 'antiNausea_medicationsCheck',
      next: {
        condition: {
          'antiNausea_medicationsCheck.none': true
        },
        key: 'antiNausea_allergicReactionAntiNausea',
        els: 'antiNausea_ineligible'
      }
    },
    {
      key: 'antiNausea_allergicReactionAntiNausea',
      next: {
        condition: {
          'antiNausea_allergicReactionAntiNausea.no': true
        },
        key: 'antiNausea_prolongedQT',
        els: 'antiNausea_ineligible'
      }
    },
    {
      key: 'antiNausea_prolongedQT',
      next: {
        condition: {
          'antiNausea_prolongedQT.no': true
        },
        key: 'antiNausea_irregularHeartbeat',
        els: 'antiNausea_ineligible'
      }
    },
    {
      key: 'antiNausea_irregularHeartbeat',
      next: {
        condition: {
          'antiNausea_irregularHeartbeat.no': true
        },
        key: 'antiNausea_finalConsent',
        els: 'antiNausea_ineligible'
      }
    },
    {
      key: 'antiNausea_finalConsent',
      next: {
        condition: { 'antiNausea_finalConsent.do_not_proceed': true },
        key: 'antiNausea_ineligible',
        els: 'antiNausea_complete'
      }
    },
    'antiNausea_complete',
    'antiNausea_ineligible'
  ]
};

export default antiNausea;
